import analystLightIcon from "./assets/filter_analyst_light.svg";
import analystBlueIcon from "./assets/filter_analyst_blue.svg";

import statusLightIcon from "./assets/filter_status_light.svg";
import statusBlueIcon from "./assets/filter_status_blue.svg";

import categoryLightIcon from "./assets/filter_category_light.svg";
import categoryBlueIcon from "./assets/filter_category_blue.svg";


import calendarLightIcon from "./assets/filter_calendar_light.svg";
import calendarBlueIcon from "./assets/filter_calendar_blue.svg";


export const icons = {
  date: {
    default: calendarLightIcon,
    active: calendarBlueIcon,
  },
  Analyst: {
    default: analystLightIcon,
    active: analystBlueIcon,
  },
  Category: {
    default: categoryLightIcon,
    active: categoryBlueIcon,
  },
  Status: {
    default: statusLightIcon,
    active: statusBlueIcon,
  },
};

export const EMPTY_LIST = "This list is empty";

export const Statuses = {					
	0	:	{
		title	:	'New',
		color	:	'#FFEE93'
	},
	1	:	{
		title	:	'Under Review',
		color	:	'#74B8FF'
	},
	2	:	{
		title	:	'Approved',
		color	:	'#4CD4AC'
	},
	3	:	{
		title	:	'Rejected',
		color	:	'#BE4F59'
	}
}